module.exports = __webpack_public_path__ + "media/audio_instruction.4aeead6e.webm";